// import { LOGIN_SUCCESS, LOGOUT, FORGOT_SUCCESS, RESET_PASSWORD } from "../actions/types"

// const initialState = {
    
//     token: '',
//     isLoggedIn: false,
// }

// export default function (state = initialState, action) {
//     const { type, payload } = action;
//     console.log("payload token",payload.token)
//     switch (type) {
//         case LOGIN_SUCCESS:
//             return {
//                 ...state,
//                 ...payload,
//                 isLoggedIn: true,
//             };
//         case LOGOUT:
//             return {
//                 ...state,
//                 ...action.payload,
//                 isLoggedIn: false,
//             };
//         case FORGOT_SUCCESS:
//             return {
//                 ...state,
//                 ...action.payload,
//                 isLoggedIn: false,
//             };
//         case RESET_PASSWORD:
//             return {
//                 ...state,
//                 ...action.payload,
//                 isLoggedIn: false,
//             };
//         default:
//             return state
//     }
// }

import { LOGIN_SUCCESS, LOGOUT, FORGOT_SUCCESS, RESET_PASSWORD } from "../actions/types";

const initialState = {
    token: localStorage.getItem("tokenData") || '', 
    isLoggedIn: !!localStorage.getItem("tokenData"), 
    user: null 
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    
    switch (type) {
        case LOGIN_SUCCESS:
            if (payload.token) {
                localStorage.setItem("tokenData", payload.token);
            }
            return {
                ...state,
                token: payload.token || state.token,
                isLoggedIn: true,
                user: payload.user || null 
            };
            
        case LOGOUT:
            localStorage.removeItem("tokenData");
            return {
                ...state,
                token: '',
                isLoggedIn: false,
                user: null
            };
            
        case FORGOT_SUCCESS:
            return {
                ...state,
                ...payload,
            };
            
        case RESET_PASSWORD:
            return {
                ...state,
                ...payload,
            };
            
        default:
            return state;
    }
}